import { SyncType } from "./sync.types";

/**
 * Determines if a sync type should be synced based on the syncTypes list and modified data checks.
 * This is a pure function extracted from Sync.synchronizeInternal to allow for testing.
 *
 * @param syncType The sync type to check
 * @param syncTypes Array of sync types that should be synced
 * @param onlySyncModifiedData If true, only sync types with modified data
 * @param hasModifiedEntitiesToSync Function to check if a sync type has modified entities
 * @returns True if the sync type should be synced
 */
export function needsSync(
    syncType: SyncType,
    syncTypes: SyncType[],
    onlySyncModifiedData: boolean,
    hasModifiedEntitiesToSync: (syncType: SyncType) => boolean
): boolean {
    if (syncTypes.indexOf(syncType) === -1) {
        return false;
    }

    if (onlySyncModifiedData && !hasModifiedEntitiesToSync(syncType)) {
        return false;
    }

    return true;
}
